/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type FieldSignatureV1Dto = {
  /**
   * UUID of the document the field belongs to
   */
  document_id: string;
  /**
   * Height of the field in pixels
   */
  height?: number;
  /**
   * ID of the field
   */
  id: string;
  /**
   * Page number the field is located on
   */
  page: number;
  /**
   * UUID of the signer the field is assigned to
   */
  signer_id: string;
  /**
   * Type of the field
   */
  type: FieldSignatureV1Dto.type;
  /**
   * Width of the field in pixels
   */
  width?: number;
  /**
   * X coordinate of the field on the page in pixels
   */
  x: number;
  /**
   * X coordinate of the field on the page in pixels
   */
  y: number;
  /**
   * Reason for the signature
   */
  reason?: string | null;
};
export namespace FieldSignatureV1Dto {
  /**
   * Type of the field
   */
  export enum type {
    CHECKBOX = 'checkbox',
    MENTION = 'mention',
    RADIO_GROUP = 'radio_group',
    SIGNATURE = 'signature',
    TEXT = 'text',
  }
}
